/**
* v-hasPermi 操作权限处理
* Copyright (c) 2019 ruoyi
*/

import store from '@/store'

export default {
  update (el, binding, vnode) {
    const { value } = binding
    const userDeptAreaCode = store.getters && store.getters.getUserDeptAreaCode
    const selectAreaCode = store.state.activeRegionObj && store.state.activeRegionObj.areaCode
    const areaPermissionsSetting = store.getters && store.getters.getAreaPermissionsSetting || []

    // 进行权限按钮父级dom存储处理，防止remove后，找不到父级
    var permiParentDomArr = store.getters && store.getters.getHasPermiDom || []

    // 当前登录账号权限
    const userRouterSeting = areaPermissionsSetting.find(v=> {
      return v.dictLabel == userDeptAreaCode
    })?.dictValue;
    // 当前选择区域权限
    const selectAreaRouterSeting = areaPermissionsSetting.find(v=> {
      return v.dictLabel == selectAreaCode
    })?.dictValue;
    const userArr = [...userRouterSeting?userRouterSeting.split(','):[]]
    const areaArr = [...selectAreaRouterSeting?selectAreaRouterSeting.split(','):[]]
    // // 登录区域和选择区域权限交集
    // const intersectArr = userArr.filter(item => areaArr.includes(item));
    // // 传入权限和交集所产生的交集
    // const permiIntersect = intersectArr.filter(item => value.includes(item));
    console.log('产生权限 :>> ', areaArr);
    if(areaArr && areaArr.length>0 || store.getters.roles.includes('admin')) {
      // 有交集 或者 是超级管理员放行，添加dom
      var parentNodeInfo = permiParentDomArr.find(v=> { return v.key == value.join(',')})
      if(parentNodeInfo) {
        parentNodeInfo.node.appendChild(el);
        // 去除父级dom存储
        store.commit('setHasPermiDom', permiParentDomArr.filter(v=> { return v.key != value.join(',')}));
      }
      parentNodeInfo = null // 防止内存溢出
    } else {
      // 否则隐藏dom
      const domArr = [...permiParentDomArr, {key: value.join(','), node: el.parentNode }]
      if(!(permiParentDomArr.some(v=>{return v.key == value.join(',')}))) { // 未找到该权限父级dom存储
        // 将父级dom存储
        store.commit('setHasPermiDom', domArr);
      }
      el.parentNode && el.parentNode.removeChild(el)
    }
    permiParentDomArr = null // 防止内存溢出
  }
}
